import { defineMessage } from "react-intl";

import { LogoDataType } from "./integrations";

//logo tooltip text and layout as determined in https://hello.atlassian.net/wiki/spaces/~396457966/pages/3547054814/WAC+homepage+-+Integrations+tooltips
const LOGOS_DATA = {
    airtable: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/air-table-3638621307.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsAirtableAltTxt",
            defaultMessage: "Airtable logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsAirtableTooltip",
            defaultMessage:
                "Embed Airtable bases, views, and forms in Confluence"
        })
    },
    asana: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/asana-363871342.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsAsanaAltTxt",
            defaultMessage: "Asana logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsAsanaTooltip",
            defaultMessage:
                "Sync Asana and Jira tasks and embed interactive task previews in either tool"
        })
    },
    balsamiq: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/balsamiq-1570513082.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsBalsamiqAltTxt",
            defaultMessage: "Balsamiq logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsBalsamiqTooltip",
            defaultMessage:
                "Present Balsamiq wireframes and prototypes in beautiful Confluence reports and design docs"
        })
    },
    canva: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/canva-363018985.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsCanvaAltTxt",
            defaultMessage: "Canva logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsCanvaTooltip",
            defaultMessage:
                "Collaborate on graphics and marketing content for company-wide access to beautiful designs"
        })
    },
    figma: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma-363833302.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsFigmaAltTxt",
            defaultMessage: "Figma logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsFigmaTooltip",
            defaultMessage: "Embed and edit files in Confluence pages"
        })
    },
    github: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/github-3505995671.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGitHubAltTxt",
            defaultMessage: "GitHub logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGitHubTooltip",
            defaultMessage: "Track branches, pull request, and commits in Jira"
        })
    },
    gitLab: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/git-lab-204839338.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGitLabAltTxt",
            defaultMessage: "GitLab logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGitLabTooltip",
            defaultMessage:
                "Update Jira issues, comment, and change task statuses from GitLab"
        })
    },
    googleAnalytics: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-analytics-3286988256.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGoogleAnalyticsAltTxt",
            defaultMessage: "Google Analytics logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGoogleAnalyticsTooltip",
            defaultMessage:
                "Sync and embed customer analytics alongside notes and reports"
        })
    },
    googleDocs: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs-2740153165.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGoogleDocsAltTxt",
            defaultMessage: "Google Docs logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGoogleDocsTooltip",
            defaultMessage: "Sync docs in Confluence keep info in one place"
        })
    },
    googleDrive: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive-2276762714.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGoogleDriveAltTxt",
            defaultMessage: "Google Drive logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGoogleDriveTooltip",
            defaultMessage: "Embed and edit files in Confluence pages"
        })
    },
    googleSheets: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-sheets-1718541418.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGoogleSheetsAltTxt",
            defaultMessage: "Google Sheets Plan logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsGoogleSheetsTooltip",
            defaultMessage:
                "Analyze Google Sheets data directly in Confluence pages and Jira issues"
        })
    },
    hotjar: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/hot-jar-1014134517.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsHotjarAltTxt",
            defaultMessage: "Hotjar logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsHotjarTooltip",
            defaultMessage:
                "Sync and embed customer research recordings and data alongside notes or reports"
        })
    },
    hubSpot: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/hubspot-3684386805.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsHubSpotAltTxt",
            defaultMessage: "HubSpot logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsHubSpotTooltip",
            defaultMessage:
                "Connect your support and dev teams to resolve customer issues faster"
        })
    },
    jenkins: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jenkins-214038284.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsJenkinsAltTxt",
            defaultMessage: "Jenkins logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsJenkinsTooltip",
            defaultMessage: "View Jenkins builds and deployments in Jira"
        })
    },
    launchDarkly: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-darkly-198811051.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsLaunchDarklyAltTxt",
            defaultMessage: "Launch Darkly logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsLaunchDarklyTooltip",
            defaultMessage:
                "Create, connect, and link LaunchDarkly feature flags to Jira"
        })
    },
    mailchimp: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/mailchimp-1767865028.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMailchimpAltTxt",
            defaultMessage: "Mailchimp logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMailchimpTooltip",
            defaultMessage:
                "Transform leads to success by surfacing Mailchimp campaigns to all teams"
        })
    },
    microsoft365: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-365-3971673211.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMicrosoft365AltTxt",
            defaultMessage: "Microsoft 365 logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMicrosoft365Tooltip",
            defaultMessage: "Add Jira issue details to your MS Office tools"
        })
    },
    microsoftTeams: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group%206273011-2525946013.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMicrosoftTeamsAltTxt",
            defaultMessage: "Microsoft Teams logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMicrosoftTeamsTooltip",
            defaultMessage: "View and update issues directly from MS Teams"
        })
    },
    miro: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273207-554690744.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMiroAltTxt",
            defaultMessage: "Miro logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMiroTooltip",
            defaultMessage: "Embed and edit files in Confluence pages"
        })
    },
    monday: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/monday-3089500834.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMondayAltTxt",
            defaultMessage: "Monday.com logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsMondayTooltip",
            defaultMessage:
                "Share boards and tasks across Monday.com and Jira to keep teams in sync"
        })
    },
    pendo: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/pendo-379684898.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsPendoAltTxt",
            defaultMessage: "Pendo logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsPendoTooltip",
            defaultMessage:
                "Capture Pendo customer feature requests and data in Jira & Confluence"
        })
    },
    productPlan: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273205-1701574714.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsProductPlanAltTxt",
            defaultMessage: "Product Plan logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsProductPlanTooltip",
            defaultMessage:
                "Quickly embed live roadmaps in Confluence pages to share with your team"
        })
    },
    qMetry: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273206-2473828409.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsQMetryAltTxt",
            defaultMessage: "QMetry logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsQMetryTooltip",
            defaultMessage: "Embed and edit files in Confluence pages"
        })
    },
    salesforce: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/salesforce-2848088583.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsSalesforceAltTxt",
            defaultMessage: "Salesforce logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsSalesforceTooltip",
            defaultMessage:
                "Link customer and technical info between Salesforce & Jira to improve customer acquisition"
        })
    },
    scriptrunner: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/script-runner-1229978336.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsScriptrunnerAltTxt",
            defaultMessage: "Scriptrunner logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsScriptrunnerTooltip",
            defaultMessage:
                "Automate and customize your team’s workflows with simple, powerful scripts in Confluence and Jira"
        })
    },
    serviceNow: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-now-3403321428.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsServiceNowAltTxt",
            defaultMessage: "ServiceNow logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsServiceNowTooltip",
            defaultMessage:
                "Auto-sync incidents, assets, and tasks between ServiceNow and Jira"
        })
    },
    slack: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack-375335524.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsSlackAltTxt",
            defaultMessage: "Slack logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsSlackTooltip",
            defaultMessage: "Work on Jira issues without leaving Slack"
        })
    },
    smartsheet: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/smartsheet-2509293444.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsSmartsheetAltTxt",
            defaultMessage: "Smartsheet Plan logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsSmartsheetTooltip",
            defaultMessage:
                "Embed Smartsheet grids, Gantt charts, cards, and calendars in Confluence"
        })
    },
    statsig: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/statsig-4214018365.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsStatsigAltTxt",
            defaultMessage: "Statsig Plan logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsStatsigTooltip",
            defaultMessage:
                "Link Statsig feature gates, metric data, and test results directly in Jira"
        })
    },
    wrike: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/wrike-368502576.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsWrikeAltTxt",
            defaultMessage: "Wrike logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsWrikeTooltip",
            defaultMessage:
                "Sync and migrate Wrike projects to Jira, or customize project workflows with scripts"
        })
    },
    zendesk: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/zendesk-97087002.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsZendeskAltTxt",
            defaultMessage: "Zendesk logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsZendeskTooltip",
            defaultMessage:
                "Streamline workflows between Zendesk support tickets and Jira issues"
        })
    },
    zoom: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom-1703389861.webp",
        alt: defineMessage({
            id: "HomePageTemplateV2.IntegrationsZoomAltTxt",
            defaultMessage: "Zoom logo"
        }),
        tooltipText: defineMessage({
            id: "HomePageTemplateV2.IntegrationsZoomTooltip",
            defaultMessage:
                "Stay updated on Jira and Confluence work right in Zoom chat"
        })
    }
};

// "rowOne" logos stay the same for all contexts
const DEFAULT_LOGOS = {
    leftRowOneData: [
        { ...LOGOS_DATA.googleDrive },
        { ...LOGOS_DATA.googleDocs },
        { ...LOGOS_DATA.slack }
    ],
    rightRowOneData: [
        { ...LOGOS_DATA.microsoftTeams },
        { ...LOGOS_DATA.zoom },
        { ...LOGOS_DATA.microsoft365 }
    ]
};

interface LogosInterface {
    leftRowTwoLogoData: [LogoDataType, LogoDataType];
    rightRowTwoLogoData: [LogoDataType, LogoDataType];
}

const FALLBACK_LOGOS: LogosInterface = {
    leftRowTwoLogoData: [{ ...LOGOS_DATA.github }, { ...LOGOS_DATA.jenkins }],
    rightRowTwoLogoData: [
        { ...LOGOS_DATA.launchDarkly },
        { ...LOGOS_DATA.gitLab }
    ]
};

const CONTEXTUAL_LOGOS: LogosInterface[] = [
    // "Software"
    {
        leftRowTwoLogoData: [
            { ...LOGOS_DATA.github },
            { ...LOGOS_DATA.jenkins }
        ],
        rightRowTwoLogoData: [
            { ...LOGOS_DATA.launchDarkly },
            { ...LOGOS_DATA.gitLab }
        ]
    },
    // "Product management"
    {
        leftRowTwoLogoData: [
            { ...LOGOS_DATA.productPlan },
            { ...LOGOS_DATA.pendo }
        ],
        rightRowTwoLogoData: [
            { ...LOGOS_DATA.statsig },
            { ...LOGOS_DATA.airtable }
        ]
    },
    // "Marketing"
    {
        leftRowTwoLogoData: [
            { ...LOGOS_DATA.salesforce },
            { ...LOGOS_DATA.hubSpot }
        ],
        rightRowTwoLogoData: [
            { ...LOGOS_DATA.googleAnalytics },
            { ...LOGOS_DATA.mailchimp }
        ]
    },
    // "Project management"
    {
        leftRowTwoLogoData: [{ ...LOGOS_DATA.asana }, { ...LOGOS_DATA.monday }],
        rightRowTwoLogoData: [
            { ...LOGOS_DATA.googleSheets },
            { ...LOGOS_DATA.smartsheet }
        ]
    },
    // "Design"
    {
        leftRowTwoLogoData: [
            { ...LOGOS_DATA.figma },
            { ...LOGOS_DATA.balsamiq }
        ],
        rightRowTwoLogoData: [{ ...LOGOS_DATA.canva }, { ...LOGOS_DATA.hotjar }]
    },
    // "IT"
    {
        leftRowTwoLogoData: [
            { ...LOGOS_DATA.scriptrunner },
            { ...LOGOS_DATA.zendesk }
        ],
        rightRowTwoLogoData: [
            { ...LOGOS_DATA.wrike },
            { ...LOGOS_DATA.serviceNow }
        ]
    }
];

export { LOGOS_DATA, CONTEXTUAL_LOGOS, DEFAULT_LOGOS, FALLBACK_LOGOS };
